import Accordion from "react-bootstrap/esm/Accordion";
import { ControlType } from "../../../base/types";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";

export const AccordionComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    return (
        <Accordion className={className} flush>
            {children}
        </Accordion>)
}

Registry.addControl({
    id: "323cafaf-623b-49e6-bce5-d246878ce045",
    name: "Accordion",
    type: ControlType.Accordion,
    properties: [],
    component: AccordionComponent
})
